import { useMemo } from "react";
import ReactApexChart from "react-apexcharts";

const DriverBookingPerformanceChart = ({ data }) => {
  const drivers = Array.isArray(data?.drivers) ? data.drivers : [];

  const categories = useMemo(
    () => drivers.map((driver) => driver?.name || "Unknown Driver"),
    [drivers]
  );

  const series = useMemo(
    () => [
      {
        name: "Assigned Bookings",
        data: drivers.map((driver) => Number(driver?.assignedBookings) || 0),
      },
      {
        name: "Completed Bookings",
        data: drivers.map((driver) => Number(driver?.completedBookings) || 0),
      },
    ],
    [drivers]
  );

const normalAxisStyle = { fontWeight: 400 };

  const options = useMemo(
    () => ({
      chart: {
        type: "bar",
        fontFamily: "inherit",
        toolbar: {
          show: false,
        },
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "45%",
          borderRadius: 6,
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        show: true,
        width: 2,
        colors: ["transparent"],
      },
      colors: ["#2D9CDB", "#27AE60"],
      legend: {
        position: "top",
        horizontalAlign: "left",
      },
      xaxis: {
        categories,
        labels: {
          style: normalAxisStyle,
        },
        title: {
          text: "Driver",
          style: normalAxisStyle,
        },
      },
      yaxis: {
        min: 0,
        forceNiceScale: true,
        labels: {
          style: normalAxisStyle,
        },
        title: {
          text: "No. of Bookings",
          style: normalAxisStyle,
        },
      },
      grid: {
        borderColor: "#f1f1f1",
      },
      tooltip: {
        shared: true,
        intersect: false,
      },
      noData: {
        text: "No driver performance data available",
      },
    }),
    [categories]
  );

  return (
    <div className="card">
      <div className="card-header">
        <h4 className="card-title mb-0">Driver Booking Performance</h4>
      </div>
      <div className="card-body">
        <div className="line-chart-style bar-chart">
          <ReactApexChart options={options} series={series} type="bar" height={360} />
        </div>
      </div>
    </div>
  );
};

export default DriverBookingPerformanceChart;
